import {configureStore, ThunkDispatch} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer, {RootState} from './reducers';
import { rootSaga } from '../sagas';
import logger from '../utils/logger';
import {AppActions} from "../actions";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
          thunk: false,
          serializableCheck: false,
      }).concat(sagaMiddleware, logger),
    devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(rootSaga);

if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./reducers', () => {
        const newRootReducer = require('./reducers').default;
        store.replaceReducer(newRootReducer);
    });
}

export type AppDispatch = ThunkDispatch<RootState, unknown, AppActions>;
